import Vue from 'vue'
import patientsgallery from '../../api/patientsgallery'

// initial state
const state = {
  patientsgallery: {root: [], totalCount: 0},
  savePatientsGalleryResponse: false,
  deletePatientsGalleryResponse: false
}

// getters
const getters = {
  patientsgallery: state => state.patientsgallery,
  savePatientsGalleryResponse: state => state.savePatientsGalleryResponse,
  deletePatientsGalleryResponse: state => state.deletePatientsGalleryResponse
}

// actions
const actions = {
  getPatientsGallery: function (context, data) {
    patientsgallery.getPatientsGallery(data, patientsgallery => {
      context.commit('RECEIVE_PATIENTS_GALLERY', { patientsgallery })
    })
  },
  savePatientsGallery: function (context, data) {
    patientsgallery.savePatientsGallery(data, savePatientsGalleryResponse => {
      context.commit('SAVE_PACIENTS_GALLERY_RESPONSE', { savePatientsGalleryResponse })
    })
  },
  deletePatientsGallery: function (context, data) {
    patientsgallery.deletePatientsGallery(data, deletePatientsGalleryResponse => {
      context.commit('DELETE_PACIENTS_GALLERY_RESPONSE', { deletePatientsGalleryResponse })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_PATIENTS_GALLERY'] (state, { patientsgallery }) {
    patientsgallery.totalCount = parseInt(patientsgallery.totalCount)
    state.patientsgallery = patientsgallery
  },
  ['SAVE_PACIENTS_GALLERY_RESPONSE'] (state, { savePatientsGalleryResponse }) {
    state.savePatientsGalleryResponse = savePatientsGalleryResponse
  },
  ['DELETE_PACIENTS_GALLERY_RESPONSE'] (state, { deletePatientsGalleryResponse }) {
    if(deletePatientsGalleryResponse.error == true) Vue.$notify.error(deletePatientsGalleryResponse.notice);
    else Vue.$notify.success(deletePatientsGalleryResponse.notice);
    state.deletePatientsGalleryResponse = deletePatientsGalleryResponse
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/patientsgallery.js